import { trackOmniClick } from "javascripts/sitebase/es/tracking";

let headerSearchActionUrl;

$(function() {
	// Updates all appropriate details of the global search form so that
	// it displays the correct information and submits to the correct url
	$(".nav-search-dropdown .dropdown-items .item").on("click", function() {
		headerSearchActionUrl = $(this).data("search-url");
		const labelText = $(this).text().trim();
		const enableSuggestion = $(this).data("enable-suggestion");
		const searchType = $(this).data("search-type");

		$("#global-search-form").attr("action", headerSearchActionUrl);
		$(".search-label .label-text").text(labelText);

		let searchBoxPlaceholderText = labelText.trim();
		if (labelText === "") {
			searchBoxPlaceholderText = "GlobalSpec";
		}
		$("#global-search-form .search-box").attr("placeholder", "Search " + searchBoxPlaceholderText);
		$("#global-search-form label[for='header-search-input']").text("Search " + searchBoxPlaceholderText);

		if (enableSuggestion) {
			$("#global-search-form .search-box").attr("data-search-method", "blended");
			$("#global-search-form .search-box").attr("data-search-method-type", searchType);
		} else {
			$("#global-search-form .search-box").removeAttr("data-search-method");
			$("#global-search-form .search-box").removeAttr("data-search-method-type");
		}
	});

	// Click event for profile icon.
	$("#reg-trigger, #log-in, #user-panel").on("click", function() {
		$("html, #menu-trigger, #site-nav").removeClass("menu-open");
		closeMobileGlobalSearch();
		$("#header-content .header-reg-links").toggleClass("active");

		$(document).on("click.document", function(e) {
			const container = $("#header-content .header-reg-links");

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				container.removeClass("active");
				// remove the click event on the document when it's no longer needed.
				$(document).off("click.document");
			}
		});
	});

	// Omniture events for login / signup
	$(".header-reg-links #sign-up").on("click", function() {
		trackOmniClick(window.s_account, 'event76', {channel: s.channel, eVar1: s.channel, eVar5: s.pageName}, 'Header Sign Up Click');
	});

	$(".header-reg-links #log-in").on("click", function() {
		trackOmniClick(window.s_account, 'event77', {channel: s.channel, eVar1: s.channel, eVar5: s.pageName}, 'Header Log In Click');
	});

	$(".menu-sign-up.menu-link").on("click", function() {
		trackOmniClick(window.s_account, 'event78', {channel: s.channel, eVar1: s.channel, eVar5: s.pageName}, 'Flyout Menu Sign Up Click');
	});

	$(".menu-log-in.menu-link").on("click", function() {
		trackOmniClick(window.s_account, 'event79', {channel: s.channel, eVar1: s.channel, eVar5: s.pageName}, 'Flyout Menu Log In Click');
	});

	// Click event for the global search dropdown
	$(".nav-search-dropdown").on("click",function() {
		$(this).toggleClass('search-dropdown-open');
		$(".nav-search-dropdown .dropdown-items").slideToggle("fast");

		$(document).on("click.document", function(e) {
			const container = $(".nav-search-dropdown");

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				$(".nav-search-dropdown .dropdown-items").slideUp();
				// remove the click event on the document when it's no longer needed.
				$(document).off("click.document");
			}
		});
	});

	// Opens main menu
	$("#menu-trigger").on("click",function() {
		$("html, #menu-trigger, #site-nav").toggleClass("menu-open");
		closeMobileGlobalSearch();
	});

	// Close main menu
	$("#sitewide-overlay").on("click",function() {
		$("html, #menu-trigger, #site-nav").removeClass("menu-open");
	});

	// Click event to open/close submenu for products, services, and news & analysis menu items
	$(".submenu-trigger").on("click",function(e) {
		e.preventDefault();
		$(this).parent("div").toggleClass("submenu-open");
	});

	// Login form validation
	$("form#eng360-login-form").validate({
		rules: {
			email: {
				required: true,
				email: {
					depends: function() {
						return $(this).val() !== "demo";
					},
				},
			},
			password: {
				required: true,
			},
		},
		errorLabelContainer: ".eng360-validation-errors",
		wrapper: "li",
		errorClass: "validation-error",
		messages: {
			email: {
				required: "Please enter your email address",
				email: "The email address must be in a valid email format.",
			},
			password: {
				required: "Please enter your password",
			},
		},
	});

	// resize youtube videos on cr4
	const YOUTUBE_RATIO = .58; // based on ratio of width to height set inline by tinyMCE

	// responsive only js
	if ($("html").hasClass("responsive-content")) {
		$(".message-text iframe, .messagebody iframe, .postFormQuotedText iframe").each(function() {
			const videoWidth = $(this).width();
			const calculatedVideoHeight = (videoWidth * YOUTUBE_RATIO) + "px";
			$(this).height(calculatedVideoHeight);
		});
	}

	// mobile Header search bar toggle
	$("#mobile-search-trigger").on("click",function(e) {
		$("#header-content .header-reg-links").removeClass("active");
		$("html, #menu-trigger, #site-nav").removeClass("menu-open");

		if ($("header").hasClass("gs-search-open")) {
			closeMobileGlobalSearch();
		} else {
			openMobileGlobalSearch();
			e.preventDefault();
			$("#global-search-form input.search-box").trigger('focus');
		}
	});

	function openMobileGlobalSearch() {
		$("header").addClass('gs-search-open');

		// BEGIN Temporary addition of banner explaining the Eng360 -> GlobalSpec rebrand - remove after 3/15/2023
		if ($("#gs-rebranding-banner").is(":visible")) {
			$("#global-search-form").css("margin-top","25px");
			$("body #site-banner, html #site-banner").css("margin-top", "65px");
		}
		// END Temporary addition of banner explaining the Eng360 -> GlobalSpec rebrand

	}

	function closeMobileGlobalSearch() {
		$("header").removeClass('gs-search-open');

		// BEGIN Temporary addition of banner explaining the Eng360 -> GlobalSpec rebrand - remove after 3/18/2023
		if ($("#gs-rebranding-banner").is(":visible")) {
			$("#global-search-form").css("margin-top","");
			$("body #site-banner, html #site-banner").css("margin-top", "40px");
		}
		// END Temporary addition of banner explaining the Eng360 -> GlobalSpec rebrand


	}

	// update the login form goToUrl if it differs from the current url
	// This should only happen if the current url has url fragments utilizing #
	// such as our search page.
	const isRegistrationPage = $("html").hasClass("reg-page");
	const currentUrl = window.location.href;
	const currentGoToUrl = $("#eng360-login-form input[name='gotoUrl']").val();
	if (currentGoToUrl !== currentUrl && !isRegistrationPage) {
		$("#eng360-login-form input[name='gotoUrl']").val(encodeURI(currentUrl));
	} else if (isRegistrationPage) {
		const regFormGoToUrl = $("#registrationForm input[name='gotoUrl']").val();
		$("#eng360-login-form input[name='gotoUrl']").val(encodeURI(regFormGoToUrl));
	}

	// umbrella link click tracking
	$('#umbrella-container a').on('click', function() {
		const linkText = $(this).text().trim();
		trackOmniClick(window.s_account,"event86",{channel: s.channel,eVar1: s.channel,eVar5: s.pageName,eVar39: linkText});
	})

	// menu link click tracking
	$('#site-nav a').on('click', function() {
		const linkText = $(this).text().trim();
		trackOmniClick(window.s_account,"event87",{channel: s.channel,eVar1: s.channel,eVar5: s.pageName,eVar39: linkText});
	})
});
